export default __webpack_public_path__ + "static/media/ic-error-red.ec4b6931.svg";